import { render, staticRenderFns } from "./WxWork.vue?vue&type=template&id=a49181be&scoped=true&"
import script from "./WxWork.vue?vue&type=script&lang=js&"
export * from "./WxWork.vue?vue&type=script&lang=js&"
import style0 from "./WxWork.vue?vue&type=style&index=0&id=a49181be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49181be",
  null
  
)

export default component.exports